import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

interface SupportedCurrencies {
  transactionCurrencies: string[];
}

export default (makeCall: MakeCall) => () =>
  makeCall<SupportedCurrencies>(
    'GET',
    `${APIV2_URL}/payment/configuration/currencies`,
  );
